var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"fields":_vm.fields,"auto_start":false,"unstable_pagination":true,"table_store":"voice/stats/detailed"},scopedSlots:_vm._u([{key:"status",fn:function(ref){
var item = ref.item;
return [_c('status-badge',{attrs:{"value":item.status}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }